var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.902,
    height: 32,
    viewBox: "0 0 31.902 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M0,4.531,13.037,2.755l.006,12.575L.012,15.4ZM13.031,16.779l.01,12.586L.01,27.574V16.7Zm1.58-14.257L31.9,0V15.171l-17.286.137ZM31.9,16.9l0,15.1L14.611,29.56,14.587,16.87Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/windows_icon.203dc8424be304c540330d6b211ff80b.svg";
export { ForwardRef as ReactComponent };